import React from "react";
import { createBrowserRouter } from "react-router-dom";
import isAuth from "../../utils/Auth";
import Accounts from "../accounts";
import DashBoard from "../dashboard";
import Login from "../login";
import Products from "../products";

export const Routes = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    loader: () => isAuth({ isProtected: true })
  },
  {
    path: "/dashboard",
    element: <DashBoard />,
    loader: isAuth
  },
  {
    path:"/products",
    element:<Products/>,
    loader: isAuth
  },
  {
    path:"/accounts",
    element:<Accounts/>,
    loader: isAuth
  }
]);
